import { render, staticRenderFns } from "./client-password.vue?vue&type=template&id=b5180ab2"
import script from "./client-password.vue?vue&type=script&lang=ts"
export * from "./client-password.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5180ab2')) {
      api.createRecord('b5180ab2', component.options)
    } else {
      api.reload('b5180ab2', component.options)
    }
    module.hot.accept("./client-password.vue?vue&type=template&id=b5180ab2", function () {
      api.rerender('b5180ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/client-password.vue"
export default component.exports